'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var mangojuiceCore = require('mangojuice-core');

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function appendUsedChunk(proc, chunkName) {
  if (chunkName) {
    var usedChunks = proc.context.chunks || {};
    usedChunks[chunkName] = true;
    proc.context.chunks = usedChunks;
  }
}

function createBlockResolver(asyncRequire, resolveState) {
  var required = false;
  var resolveRequirePromise = null;
  var requirePromise = new Promise(function (r) {
    return resolveRequirePromise = r;
  });

  var runQueuedCommand = function runQueuedCommand(model) {
    var queue = resolveState.cmds;
    resolveState.cmds = [];
    var proc = mangojuiceCore.procOf(model, true);

    if (proc && queue.length) {
      mangojuiceCore.utils.maybeForEach(queue, function (_ref) {
        var _proc$logic;

        var args = _ref.args,
            name = _ref.name;
        proc.exec((_proc$logic = proc.logic)[name].apply(_proc$logic, toConsumableArray(args)));
      });
    }
  };

  var restartModelBlock = function restartModelBlock(model) {
    if (!model) return; // Make real model

    var modelArgs = model.__args;

    if (modelArgs) {
      var _resolveState$block;

      delete model.__args;

      var actualModel = (_resolveState$block = resolveState.block).createModel.apply(_resolveState$block, toConsumableArray(modelArgs));

      Object.assign(model, actualModel);
    } // Run real process


    var proc = modelArgs && mangojuiceCore.procOf(model, true);

    if (proc) {
      delete proc.config;
      proc.logic = new resolveState.lazyLogic();
      proc.bind(model);
      proc.run();
    }
  };

  var handleRequireResult = function handleRequireResult(actualBlock) {
    var block = actualBlock && actualBlock.Logic ? actualBlock : actualBlock.default;
    resolveState.block = block;
    resolveState.lazyLogic.prototype = block.Logic.prototype;
    resolveRequirePromise(block);
  };

  var resolver = function resolver(newModel) {
    var resolveHandler = function resolveHandler() {
      restartModelBlock(newModel);
      runQueuedCommand(newModel);
    };

    if (resolveState.block) {
      return resolveHandler();
    }

    if (!required) {
      required = true;
      var proc = mangojuiceCore.procOf(newModel);
      appendUsedChunk(proc, resolveState.chunkName);
      var res = asyncRequire(proc);

      if (mangojuiceCore.utils.is.promise(res)) {
        res.then(handleRequireResult);
      } else {
        handleRequireResult(res);
      }
    }

    return requirePromise.then(resolveHandler);
  };

  return resolver;
}

function createLazyLogic(resolveState, lazyCommands) {
  // Basic lazy block
  function LazyBlock() {}

  mangojuiceCore.utils.extend(LazyBlock.prototype, mangojuiceCore.LogicBase.prototype); // Define all exported lazy commands

  var lazyProto = LazyBlock.prototype;
  mangojuiceCore.utils.maybeForEach(lazyCommands, function (name) {
    lazyProto[name] = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      resolveState.cmds.push({
        args: args,
        name: name
      });
      resolveState.resolver(this.model);
    };

    mangojuiceCore.defineCommand(lazyProto, name, mangojuiceCore.cmd({
      internal: true,
      name: name + '.Lazy'
    }));
  });
  resolveState.lazyLogic = LazyBlock;
  return LazyBlock;
}

function createLazyView(resolveState) {
  var loadingView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mangojuiceCore.utils.noop;
  return function (props, context) {
    resolveState.resolver(props.model);
    var block = resolveState.block;
    return block && block.View ? block.View(props, context) : loadingView(props, context);
  };
}

function createLazyModel(resolveState, initModel) {
  return function () {
    var _resolveState$block2;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return resolveState.block ? (_resolveState$block2 = resolveState.block).createModel.apply(_resolveState$block2, args) : _extends({}, initModel, {
      __args: args
    });
  };
}
/**
 * Creates a Block which works as a proxy for some other block,
 * which will be returned by `resolver` function provided in the
 * options object. `resolver` can also return a promise which should
 * resolve and actual block.
 *
 * @param  {function} options.resolver
 * @param  {string} options.chunkName
 * @param  {string} options.initModel
 * @param  {function} options.loadingView
 * @param  {Object} options.lazyCommands
 * @return {Object}
 */


function createLazyBlock() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      resolver = _ref2.resolver,
      chunkName = _ref2.chunkName,
      initModel = _ref2.initModel,
      loadingView = _ref2.loadingView,
      lazyCommands = _ref2.lazyCommands;

  var resolveState = {
    resolver: null,
    block: null,
    cmds: [],
    chunkName: chunkName
  };
  resolveState.resolver = createBlockResolver(resolver, resolveState);
  var lazyLogic = createLazyLogic(resolveState, lazyCommands);
  var lazyView = createLazyView(resolveState, loadingView);
  var lazyCreateModel = createLazyModel(resolveState, initModel);
  return {
    resolver: resolveState.resolver,
    Logic: lazyLogic,
    View: lazyView,
    createModel: lazyCreateModel
  };
}
/**
 * Returns all used chunks while execution of the logic
 * by given proc logic
 * @param  {Process} proc
 * @return {Array<string>}
 */


function getUsedChunks(proc) {
  var chunks = proc.context.chunks || {};
  return Object.keys(chunks);
}

exports.createLazyBlock = createLazyBlock;
exports.getUsedChunks = getUsedChunks;